import { Waveform } from "@uiball/loaders";

const Wave = ({ color = "black", size = 40, lineWeight = 2.5 }) => (
  <Waveform size={size} lineWeight={lineWeight} speed={1} color={color} />
);

export default Wave;
